export default __webpack_public_path__ + "static/media/storageUnit1-beforeA-2048w.8a659df1.avif";